//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "@/assets/js/common";
import gotoRegister from "@/components/gotoRegister";
export default {
  name: "app",
  
  components: {
    gotoRegister,
  },
  data() {
    return {
      transitionName: "go",
      mineIndex: 0,
      WeChat: false,
      innerHeight:"500px"
    };
  },
  created(){
    this.innerHeight = window.innerHeight + "px";
  },
  mounted() {
    var ua = window.navigator.userAgent.toLowerCase();
    // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
    if (ua.indexOf("micromessenger") > -1) {
      // 是微信端
      this.WeChat = false;
    } else {
      this.WeChat = false;
    }

    let currentUrl = window.location;
    if (
      !common.getCookie("weChatPubNo") &&
      currentUrl.toString().indexOf("weChatPubNo") > -1
    ) {
      common.setCookie("weChatPubNo", "weChatPubNo");
    }
    this.getdata();
    common.setCookie("fromWeb_mobile", "fromWeb_mobile");
  },
  methods: {
    getdata() {
      common.getData(
        this,
        common.urls().datasUrl,
        "get",
        {},
        this.initDatasCallback
      );
    },
    initDatasCallback(res) {
      if (res.data.status == "success") {
        res.data.data.certTypes.forEach(function (el, ind, arr) {
          el.key = ind;
          el.value = el.name;
        });
        res.data.data.nations.forEach(function (el, ind, arr) {
          el.key = ind;
          el.value = el.name;
        });
        res.data.data.occupations.forEach(function (el, ind, arr) {
          el.key = ind;
          el.value = el.name;
        });
        res.data.data.letterReasons.forEach(function (el, ind, arr) {
          el.key = ind;
          el.value = el.name;
        });
        this.$store.commit("setDatas", res.data);
        this.$store.commit("updateDatas", res.data.data);
      } else {
        this.$vux.toast.show({
          type: "text",
          text: res.data.message,
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/App.vue